import React from 'react'
import { OutboundLink as GAOutboundLink } from 'gatsby-plugin-google-analytics'

function OutboundLink(props) {
  return <GAOutboundLink {...props} target="_blank" rel="noopener noreferrer">{props.children}</GAOutboundLink>
}

export default OutboundLink